var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.efficiency)?_c('div',{staticClass:"p-efficiency"},[_c('b-card-text',{staticClass:"eff-text"},[_vm._v("Production efficiency")]),_c('b-row',[_c('b-col',{staticClass:"is-flex"},_vm._l((_vm.options),function({ key, title }){return _c('kuni-eff-info',{key:key,attrs:{"title":title,"value":_vm.efficiency[key]}})}),1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }